import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoindorecab() {



  const cardData = {




keyword: "Pune to Indore Cab",

headingDescription: "Garud Cab Service provides comfortable and reliable Pune to Indore Cab Service for families, couples, business travelers, students, senior citizens, and groups planning a convenient long-distance journey. Customers can book chauffeur-driven Sedan, SUV, Ertiga, Innova, Innova Crysta, Tempo Traveller, and other suitable vehicles for one-way travel, round trips, business visits, family functions, educational travel, religious journeys, and customized Indore travel plans. With experienced drivers, clean and well-maintained vehicles, comfortable seating, practical luggage space, flexible pickup locations across Pune, transparent pricing, and 24/7 customer assistance, Garud Cab Service makes the journey from Pune to Indore smooth and convenient. Travelers can also customize their itinerary to cover temples, historic landmarks, markets, natural attractions, and nearby destinations around Indore according to their preferred schedule.",

topPlaces: [
  {
    title: "Rajwada Palace",
    description: "Rajwada Palace is one of Indore's most recognizable historic landmarks and reflects the city's rich Maratha and Holkar heritage. Located in the heart of the old city, it is surrounded by traditional markets and cultural attractions. Travelers from Pune can book a private cab to Indore and conveniently include Rajwada in a customized sightseeing itinerary."
  },
  {
    title: "Lal Bagh Palace",
    description: "Lal Bagh Palace is a magnificent heritage palace associated with the Holkar dynasty and is known for its grand architecture, historic interiors, and landscaped surroundings. It is an excellent destination for visitors interested in royal history and architecture. Garud Cab Service provides comfortable private transportation from Pune with flexible sightseeing arrangements."
  },
  {
    title: "Khajrana Ganesh Temple",
    description: "Khajrana Ganesh Temple is one of Indore's most visited religious attractions and is dedicated to Lord Ganesha. Devotees from different parts of Maharashtra and Madhya Pradesh visit the temple throughout the year. Customers traveling from Pune can include Khajrana Ganesh Temple in their pilgrimage itinerary with convenient chauffeur-driven cab service."
  },
  {
    title: "Sarafa Bazaar",
    description: "Sarafa Bazaar is a famous Indore market that becomes particularly popular in the evening for its wide variety of traditional street food and local delicacies. It offers visitors an opportunity to experience the city's food culture and lively atmosphere. Travelers can comfortably reach Sarafa Bazaar by private cab while exploring Indore's major attractions."
  },
  {
    title: "Patalpani Waterfall",
    description: "Patalpani Waterfall is a scenic natural attraction near Indore surrounded by hills and greenery and is especially attractive during the monsoon season. It is a popular destination for nature lovers, photographers, and weekend travelers. Garud Cab Service can arrange a private cab from Pune and include Patalpani in a customized Indore sightseeing plan."
  },
  {
    title: "Mandu",
    description: "Mandu is a historic destination in Madhya Pradesh known for magnificent Afghan-style architecture, forts, palaces, gateways, and scenic landscapes. Travelers from Pune visiting Indore can extend their journey toward Mandu for a heritage-focused road trip. Customers can book a private cab and customize the route to include multiple historical attractions."
  },
  {
    title: "Omkareshwar",
    description: "Omkareshwar is an important pilgrimage destination on the Narmada River and is traditionally recognized as one of the twelve Jyotirlingas dedicated to Lord Shiva. Devotees traveling from Pune can combine Omkareshwar with Indore in a religious road journey. Garud Cab Service offers comfortable vehicles and flexible one-way, return, and multi-destination travel options."
  },
  {
    title: "Maheshwar",
    description: "Maheshwar is a beautiful heritage town on the banks of the Narmada River, known for its fort, temples, ghats, and traditional Maheshwari handloom heritage. It is an excellent destination for travelers interested in culture, architecture, and peaceful riverside surroundings. Customers can include Maheshwar in a customized Pune to Indore cab itinerary."
  },
  {
    title: "Ujjain",
    description: "Ujjain is one of India's major pilgrimage cities and is famous for the Mahakaleshwar Jyotirlinga and other important temples along the Shipra River. Travelers from Pune can combine Ujjain with Indore for a spiritual and cultural journey. A private chauffeur-driven cab provides comfortable transportation between the two destinations with flexible travel arrangements."
  },
  {
    title: "Janapav Hill",
    description: "Janapav Hill is a scenic destination near Indore known for its elevated landscapes, greenery, and peaceful surroundings. It is associated with local religious traditions and attracts visitors interested in nature and spirituality. Garud Cab Service can arrange a private cab from Pune for travelers who want to include Janapav Hill in a customized Indore and nearby sightseeing itinerary."
  }
],



"services": [
{
"name": "Cab from Indore to Pune",
"description": "Book a Cab from Indore to Pune for comfortable and convenient intercity transportation with professional chauffeurs and well-maintained AC vehicles. The service is suitable for families, business travelers, tourists, students, and individuals looking for private travel between Indore and Pune."
},
{
"name": "Indore to Pune Cab",
"description": "Choose Indore to Pune Cab for a comfortable and practical journey with convenient pickup arrangements. Sedan, SUV, Innova, and premium vehicle options can be selected according to passenger count, luggage, travel schedule, and comfort preferences."
},
{
"name": "Indore to Pune Taxi",
"description": "Book Indore to Pune Taxi for convenient private transportation with experienced chauffeurs and comfortable AC vehicles. The service is suitable for families, corporate passengers, tourists, and individuals requiring direct interstate travel."
},
{
"name": "Pune to Indore Cab Booking",
"description": "Make Pune to Indore Cab Booking for a scheduled private journey with convenient vehicle selection and pickup arrangements. Sedan, SUV, Innova, and premium options can be selected according to passenger requirements, luggage, and preferred travel time."
},
{
"name": "Pune to Indore Cab Service",
"description": "Book Pune to Indore Cab Service for reliable chauffeur-driven transportation between Pune and Indore. The service is suitable for business travelers, families, tourists, students, and individuals planning comfortable long-distance interstate travel."
},
{
"name": "Pune to Indore Taxi",
"description": "Choose Pune to Indore Taxi for a comfortable and convenient road journey with professional chauffeur assistance. Suitable vehicle options can be arranged for personal travel, family visits, corporate journeys, sightseeing, and long-distance transportation."
},
{
"name": "Pune to Indore Cab",
"description": "Reserve Pune to Indore Cab for direct private transportation from your preferred Pune location to Indore. Comfortable AC vehicles and experienced drivers make the service suitable for individuals, families, corporate travelers, and tourists."
},
{
"name": "Pune to Indore Taxi Service",
"description": "Choose Pune to Indore Taxi Service for comfortable interstate travel with professional drivers and flexible pickup arrangements. Sedan, SUV, Innova, and premium vehicles can be selected according to passenger count and luggage requirements."
},
{
"name": "Cab from Pune to Indore",
"description": "Book a Cab from Pune to Indore for convenient point-to-point transportation with private chauffeur service. The journey is suitable for business trips, family travel, personal visits, tourism, and passengers requiring comfortable long-distance transportation."
},
{
"name": "Taxi from Pune to Indore",
"description": "Reserve a Taxi from Pune to Indore for a comfortable interstate journey with convenient pickup and direct destination drop. Practical sedan, spacious SUV, Innova, and premium taxi options can be arranged according to travel needs."
},
{
"name": "Pune to Indore Outstation Cab",
"description": "Choose Pune to Indore Outstation Cab for comfortable long-distance transportation outside Maharashtra. The service provides private chauffeur-driven travel suitable for families, business travelers, tourists, corporate passengers, and individuals planning interstate journeys."
},
{
"name": "Pune to Indore Car Rentals",
"description": "Book Pune to Indore Car Rentals for convenient chauffeur-driven transportation with a choice of comfortable vehicles. Sedan, SUV, Ertiga, Innova, Innova Crysta, and premium cars can be arranged according to passenger capacity, luggage, and travel requirements."
},
{
"name": "Pune to Indore Taxi Booking Online",
"description": "Book Pune to Indore Taxi Booking Online for convenient advance travel planning from Pune to Indore. Customers can arrange chauffeur-driven vehicles according to their preferred pickup time, passenger count, vehicle category, and journey requirements."
},
{
"name": "Pune to Indore Cab Fare",
"description": "Check Pune to Indore Cab Fare according to the selected vehicle category, pickup location, destination, journey type, and travel requirements. Sedan, SUV, Innova, and premium cab options can be arranged for comfortable private transportation."
},
{
"name": "Pune to Indore Taxi Fare",
"description": "Find Pune to Indore Taxi Fare based on vehicle type, pickup location, travel schedule, and journey requirements. Customers can choose practical sedan, spacious SUV, Innova, or premium vehicles according to their comfort and passenger needs."
},
{
"name": "Pune to Indore Cab Price",
"description": "Check Pune to Indore Cab Price according to vehicle category, pickup point, travel schedule, and journey requirements. Comfortable chauffeur-driven cars can be arranged for individuals, families, corporate passengers, tourists, and groups."
},
{
"name": "Pune to Indore Taxi Charges",
"description": "Check Pune to Indore Taxi Charges based on the selected vehicle and overall travel requirements. Sedan, SUV, Innova, and premium taxi options can be arranged for family trips, business travel, sightseeing, personal visits, and long-distance journeys."
},
{
"name": "Best Pune to Indore Cab Service",
"description": "Choose the Best Pune to Indore Cab Service for comfortable private transportation supported by professional chauffeurs and well-maintained vehicles. The service is suitable for business travel, family journeys, sightseeing, personal trips, and interstate road travel."
},
{
"name": "Cheap Pune to Indore Cab",
"description": "Book a Cheap Pune to Indore Cab for economical private transportation with practical vehicle options. Sedan and other suitable cars can be arranged for individuals, families, students, business travelers, and passengers looking for budget-friendly long-distance travel."
},
{
"name": "Pune to Indore One Way Cab",
"description": "Choose Pune to Indore One Way Cab for convenient point-to-point transportation without requiring a return booking. The service is suitable for relocation, business travel, family visits, personal journeys, and passengers traveling to Indore for a one-way trip."
},
{
"name": "Pune to Indore Round Trip Taxi",
"description": "Book Pune to Indore Round Trip Taxi for convenient travel with return transportation included in the journey plan. The service is suitable for families, corporate travelers, tourists, and passengers planning meetings, sightseeing, personal visits, or extended stays."
},
{
"name": "Pune to Indore Innova Cab",
"description": "Choose Pune to Indore Innova Cab for spacious and comfortable transportation suitable for families and small groups. The vehicle provides practical seating and luggage space for long-distance travel, business trips, sightseeing, and personal journeys."
},
{
"name": "Pune to Indore Innova Crysta Cab",
"description": "Book Pune to Indore Innova Crysta Cab for premium and spacious interstate travel with comfortable interiors and professional chauffeur service. It is suitable for families, executives, corporate passengers, tourists, and groups seeking enhanced comfort."
},
{
"name": "Pune to Indore Ertiga Cab",
"description": "Choose Pune to Indore Ertiga Cab for comfortable group travel with practical seating and luggage capacity. The vehicle is suitable for families, small groups, corporate passengers, and travelers looking for convenient long-distance transportation."
},
{
"name": "Pune to Indore Sedan Cab",
"description": "Book Pune to Indore Sedan Cab for comfortable AC transportation suitable for individuals, couples, and small families. Sedan travel provides practical seating and luggage space for business trips, personal visits, and long-distance journeys."
},
{
"name": "Pune to Indore SUV Taxi",
"description": "Choose Pune to Indore SUV Taxi for spacious and comfortable transportation with additional seating and luggage capacity. The service is suitable for families, groups, corporate travelers, tourists, and passengers planning an extended road journey."
},
{
"name": "Pune to Indore AC Cab",
"description": "Book Pune to Indore AC Cab for comfortable climate-controlled travel throughout the interstate journey. The service is suitable for families, business travelers, tourists, and individuals who prefer private transportation with professional chauffeur assistance."
},
{
"name": "Pune to Indore Luxury Cab",
"description": "Choose Pune to Indore Luxury Cab for premium chauffeur-driven transportation with enhanced comfort and refined interiors. The service is suitable for executives, corporate travelers, special guests, families, and customers seeking a premium long-distance travel experience."
},
{
"name": "Pune to Indore Business Travel Cab",
"description": "Book Pune to Indore Business Travel Cab for professional transportation for meetings, corporate visits, client appointments, and work-related journeys. Comfortable sedan, SUV, Innova, and premium vehicles can be arranged according to business travel requirements."
},
{
"name": "Pune to Indore Family Trip Cab",
"description": "Choose Pune to Indore Family Trip Cab for spacious and comfortable transportation for family journeys. Suitable vehicle options can accommodate passengers and luggage while providing convenient pickup, private travel, and direct destination drop."
},
{
"name": "Pune to Indore Long Distance Taxi",
"description": "Book Pune to Indore Long Distance Taxi for comfortable interstate transportation over an extended travel distance. Spacious AC vehicles and professional chauffeurs are suitable for families, business travelers, tourists, groups, and passengers planning private road trips."
},
{
"name": "Pune to Indore Night Travel Cab",
"description": "Choose Pune to Indore Night Travel Cab for convenient private transportation during nighttime journeys. Comfortable AC vehicles with professional chauffeurs can be arranged for passengers requiring scheduled long-distance travel from Pune to Indore."
},
{
"name": "Pune to Indore Religious Tour Cab",
"description": "Book Pune to Indore Religious Tour Cab for comfortable private transportation for pilgrimage and spiritual journeys. The service is suitable for families, devotees, senior passengers, and groups planning religious visits around Indore and nearby destinations."
},
{
"name": "Pune to Bhopal Cab",
"description": "Choose Pune to Bhopal Cab for comfortable private transportation between Pune and Bhopal. The service is suitable for families, business travelers, tourists, corporate passengers, and individuals requiring direct chauffeur-driven interstate travel."
},
{
"name": "Pune to Bhopal Taxi",
"description": "Book Pune to Bhopal Taxi for a convenient long-distance journey with comfortable AC vehicles and professional chauffeur service. Sedan, SUV, Innova, and premium options can be selected according to passenger count, luggage, and travel preferences."
},
{
"name": "Pune to Ujjain Cab",
"description": "Choose Pune to Ujjain Cab for convenient private transportation to Ujjain with professional chauffeur assistance. The service is suitable for families, tourists, devotees, business travelers, and passengers planning comfortable long-distance travel."
},
{
"name": "Pune to Ujjain Mahakal Darshan Cab",
"description": "Book Pune to Ujjain Mahakal Darshan Cab for comfortable private transportation for devotees visiting Mahakaleshwar Temple. Suitable vehicles can be arranged for families, senior passengers, groups, and pilgrims planning a convenient religious journey from Pune."
},
{
"name": "Pune to Jabalpur Cab",
"description": "Choose Pune to Jabalpur Cab for comfortable long-distance transportation between Pune and Jabalpur. The service is suitable for families, corporate passengers, tourists, students, and individuals requiring private chauffeur-driven interstate travel."
},
{
"name": "Pune to Jabalpur Taxi",
"description": "Book Pune to Jabalpur Taxi for convenient private transportation with comfortable seating, AC vehicles, and professional drivers. The service can be arranged for family journeys, business travel, tourism, personal visits, and long-distance road trips."
},
{
"name": "Pune to Gwalior Cab",
"description": "Choose Pune to Gwalior Cab for comfortable interstate transportation with convenient pickup from Pune. Sedan, SUV, Innova, and premium vehicles can be arranged for families, tourists, business travelers, and individuals planning private long-distance travel."
},
{
"name": "Pune to Gwalior Taxi",
"description": "Book Pune to Gwalior Taxi for convenient chauffeur-driven travel between Pune and Gwalior. The service is suitable for business trips, family visits, tourism, personal journeys, and passengers requiring comfortable interstate transportation."
},
{
"name": "Pune to Madhya Pradesh Religious Tour Cab",
"description": "Choose Pune to Madhya Pradesh Religious Tour Cab for private transportation covering planned pilgrimage destinations across Madhya Pradesh. The service is suitable for devotees, families, senior passengers, and groups seeking comfortable chauffeur-driven religious travel."
},
{
"name": "Pune to Ujjain Omkareshwar Cab",
"description": "Book Pune to Ujjain Omkareshwar Cab for a convenient private pilgrimage journey covering Ujjain and Omkareshwar. Comfortable vehicles with professional chauffeurs can be arranged for families, devotees, groups, and travelers planning temple visits."
},
{
"name": "Pune to Madhya Pradesh Family Trip Cab",
"description": "Choose Pune to Madhya Pradesh Family Trip Cab for comfortable private travel across popular destinations in Madhya Pradesh. Spacious vehicles can accommodate families and luggage while providing convenient pickup, sightseeing flexibility, and direct travel."
},
{
"name": "Pune to Madhya Pradesh Business Travel Taxi",
"description": "Book Pune to Madhya Pradesh Business Travel Taxi for professional transportation for meetings, corporate visits, client appointments, and business-related journeys. Comfortable sedan, SUV, Innova, and premium vehicles can be arranged according to corporate travel requirements."
},
{
"name": "Pune to Madhya Pradesh Sightseeing Cab",
"description": "Choose Pune to Madhya Pradesh Sightseeing Cab for comfortable private transportation to explore destinations across Madhya Pradesh. The service is suitable for families, tourists, groups, and travelers looking for flexible chauffeur-driven sightseeing and long-distance travel."
}
],
"tableData": [
["Cab from Indore to Pune", "Indore to Pune Cab"],
["Indore to Pune Taxi", "Pune to Indore Cab Booking"],
["Pune to Indore Cab Service", "Pune to Indore Taxi"],
["Pune to Indore Cab", "Pune to Indore Taxi Service"],
["Cab from Pune to Indore", "Taxi from Pune to Indore"],
["Pune to Indore Outstation Cab", "Pune to Indore Car Rentals"],
["Pune to Indore Taxi Booking Online", "Pune to Indore Cab Fare"],
["Pune to Indore Taxi Fare", "Pune to Indore Cab Price"],
["Pune to Indore Taxi Charges", "Best Pune to Indore Cab Service"],
["Cheap Pune to Indore Cab", "Pune to Indore One Way Cab"],
["Pune to Indore Round Trip Taxi", "Pune to Indore Innova Cab"],
["Pune to Indore Innova Crysta Cab", "Pune to Indore Ertiga Cab"],
["Pune to Indore Sedan Cab", "Pune to Indore SUV Taxi"],
["Pune to Indore AC Cab", "Pune to Indore Luxury Cab"],
["Pune to Indore Business Travel Cab", "Pune to Indore Family Trip Cab"],
["Pune to Indore Long Distance Taxi", "Pune to Indore Night Travel Cab"],
["Pune to Indore Religious Tour Cab", "Pune to Bhopal Cab"],
["Pune to Bhopal Taxi", "Pune to Ujjain Cab"],
["Pune to Ujjain Mahakal Darshan Cab", "Pune to Jabalpur Cab"],
["Pune to Jabalpur Taxi", "Pune to Gwalior Cab"],
["Pune to Gwalior Taxi", "Pune to Madhya Pradesh Religious Tour Cab"],
["Pune to Ujjain Omkareshwar Cab", "Pune to Madhya Pradesh Family Trip Cab"],
["Pune to Madhya Pradesh Business Travel Taxi", "Pune to Madhya Pradesh Sightseeing Cab"]
],



whychoose: [
  {
    WhyChooseheading: "Pune to Indore Cab for Convenient Long-Distance Travel",
    WhyChoosedescription: "Garud Cab Service provides private Pune to Indore cab services for families, professionals, students, couples, and groups who prefer a direct and comfortable road journey for personal, business, educational, or family-related travel."
  },
  {
    WhyChooseheading: "Direct Pickup from Your Preferred Pune Location",
    WhyChoosedescription: "Start your Indore journey from a convenient location in Pune such as your home, hotel, office, residential area, or railway station vicinity and travel directly to your selected destination in Indore."
  },
  {
    WhyChooseheading: "Spacious Travel for Families & Groups",
    WhyChoosedescription: "Families and groups can select a suitable cab according to their passenger count and luggage requirements, allowing everyone to travel together without the inconvenience of changing vehicles."
  },
  {
    WhyChooseheading: "A Practical Choice for Business Travel",
    WhyChoosedescription: "Professionals can use Pune to Indore cab services for office visits, client meetings, project assignments, industrial travel, conferences, site work, and other scheduled business requirements."
  },
  {
    WhyChooseheading: "One-Way Cab for Flexible Plans",
    WhyChoosedescription: "Choose a one-way cab when you require a direct drop in Indore for relocation, education, personal work, family visits, or professional commitments without booking the same cab for the return."
  },
  {
    WhyChooseheading: "Round-Trip Booking for Planned Returns",
    WhyChoosedescription: "Travellers who have a fixed return schedule can arrange a round-trip cab around their Indore visit, business appointment, family plans, sightseeing program, or preferred return date."
  },
  {
    WhyChooseheading: "Useful for Indore Tourism & Nearby Travel",
    WhyChoosedescription: "Private road travel can be planned for Indore sightseeing and nearby destinations according to your itinerary, making the service suitable for holiday trips, family outings, and multi-day travel."
  },
  {
    WhyChooseheading: "Easy Booking with Garud Cab Service",
    WhyChoosedescription: "Provide your Pune pickup point, Indore destination, travel date, passenger details, luggage requirements, preferred vehicle, and trip type to Garud Cab Service for a suitable cab arrangement."
  }
]


};


const faqData = [
  {
    question: "Does Garud Cab Service provide Pune to Indore Cab Service?",
    answer: "Yes, Garud Cab Service provides private Pune to Indore cab services for families, professionals, students, couples, groups, business travel, personal visits, and other long-distance journeys."
  },
  {
    question: "Can I book a one-way cab from Pune to Indore?",
    answer: "Yes, one-way cab service is available for passengers who need direct transportation from Pune to their preferred destination in Indore."
  },
  {
    question: "Can I book a round-trip Pune to Indore cab?",
    answer: "Yes, round-trip cab arrangements can be planned according to your Indore visit, business schedule, family plans, sightseeing itinerary, or preferred return date."
  },
  {
    question: "Is Pune to Indore cab suitable for families?",
    answer: "Yes, private cab travel is suitable for families and groups who want to travel together with convenient pickup, comfortable seating, and luggage arrangements."
  },
  {
    question: "Can I use the cab for business travel to Indore?",
    answer: "Yes, the service can be used for client meetings, office visits, project work, industrial travel, conferences, site inspections, and other professional transportation requirements."
  },
  {
    question: "Can I use the cab for an Indore sightseeing trip?",
    answer: "Yes, the cab can be used for planned Indore sightseeing and nearby travel according to your preferred attractions, schedule, and trip duration."
  },
  {
    question: "Can I book a cab for relocation from Pune to Indore?",
    answer: "Yes, a private cab can be considered for relocation or personal shifting requirements depending on the luggage quantity and available space in the selected vehicle."
  },
  {
    question: "Can I get pickup from my home in Pune?",
    answer: "Yes, pickup can be arranged from your home, hotel, office, residential society, railway station area, or another preferred location in Pune."
  },
  {
    question: "Can I travel with luggage in the Pune to Indore cab?",
    answer: "Yes, passengers can carry luggage according to the available capacity of the selected vehicle. Larger luggage requirements should be shared while booking."
  },
  {
    question: "How can I book a Pune to Indore Cab?",
    answer: "Share your Pune pickup location, Indore destination, travel date, passenger details, luggage requirements, preferred vehicle, and one-way or round-trip preference with Garud Cab Service."
  }
];


const testimonials = [
  {
    id: 1,
    name: "Mr. Saurabh Joshi",
    feedback: "We booked a private Pune to Indore cab for a family visit. Travelling together with our luggage was convenient, and having a direct road journey made the trip easier to plan.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Nandini Patil",
    feedback: "I arranged a Pune to Indore cab for work-related travel. The private vehicle was a convenient option because I could plan the journey around my professional schedule.",
    rating: 5
  }
];



















  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Pune to Mumbai Airport Cab",
      link: "pune-to-mumbai-airport-cab-service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Pune to Outstation Cabs",
      link: "Pune-to-Outstation-Cabs",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Pune to Mahabaleshwar Cab",
      link: "pune-to-mahabaleshwar-cab-service",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Pune to Lonavala Cab",
      link: "pune-to-lonavala-cab-service",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Pune to Matheran Cabs",
      link: "pune-to-matheran-cab-service",
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Pune to 5 Jyotirlinga Darshan Cab",
      link: "pune-to-5-jyotirlinga-cab-service",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Pune to Bhimashankar Cab",
      link: "pune-to-bhimashankar-cab-service",
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Pune to Aurangabad Cab Service",
      link: "Pune-to-Aurangabad-Cab-Service",
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Pune to Nashik Cab Service",
      link: "Pune-to-Nashik-Cab-Service",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Pune to Kolhapur Cab Service",
      link: "Pune-to-Kolhapur-Cab-Service",
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Pune to Alibaug Cab",
      link: "Pune-to-Alibaug-Cab",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/13.jpg",
      text: "Goa to Pune Cabs",
      link: "Goa-to-Pune-Cabs",
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Innova Crysta Cab in Pune",
      link: "Innova-Crysta-Cab-in-Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Ertiga On Rent in Pune",
      link: "Ertiga-On-Rent-in-Pune",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Ashtavinayak Cabs",
      link: "pune-to-ashtavinayak-cab-service",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Goa Cabs",
      link: "Pune-to-Goa-Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Jyotirlinga Darshan Package",
      link: "Pune-to-Jyotirlinga-Darshan-Package",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Akkalkot Cabs",
      link: "Pune-to-Akkalkot-Cabs",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Pandharpur Cab",
      link: "Pune-to-Pandharpur-Cab",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Grishneshwar Jyotirlinga Cab",
      link: "Pune-to-Grishneshwar-Jyotirlinga-Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Mumbai Cabs",
      link: "pune-to-mumbai-cab-service",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Alibag Cab",
      link: "Pune-to-Alibag-Cab",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Innova Crysta On Rent in Pune",
      link: "Innova-Crysta-On-Rent-in-Pune",
    },

  ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Indore Cab",
  "image": "https://garudcabs.com/assets/images/pune-to-indore-cab.webp",
  "description": "Book Pune to Indore Cab with Garud Cab for safe, comfortable, and reliable intercity travel. Get Pune to Indore cab, taxi, and booking services for one way and round trip journeys, business travel, family trips, and outstation transportation. Return travel from Indore to Pune is also available with Sedan, Ertiga, SUV, Innova, and Innova Crysta options for convenient pickup and drop.",
  "brand": {
    "@type": "Brand",
    "name": "Garud Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7934"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://garudcabs.com/pune-to-indore-cab"
  }
};


  return (
    <div>


<Helmet>
  <title>Pune to Indore Cab | One Way Taxi & Cab Booking | +91 9970007784</title>

  <meta
    name="description"
    content="Book Pune to Indore Cab with Garud Cab for comfortable and reliable intercity travel. Get one way and round trip taxi services between Pune and Indore with Sedan, Ertiga, SUV, Innova, and Innova Crysta cab options."
  />

  <meta
    name="keywords"
    content="Cab from Indore to Pune, Indore to Pune Cab, Indore to Pune Taxi, Pune to Indore Cab Booking, Pune to Indore Cab Service, Pune to Indore Taxi, Pune to Indore Cab, Pune to Indore One Way Cab, Pune to Indore Outstation Cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>





      <section className="page-banner">
        <div className="page-banner-container">
          <h2>
            {cardData.keyword}
          </h2>
        </div>
      </section>








      <section>
        <div className="container-fluid p-0" >
          <div className="row container-fluid px-md-2">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/77.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Garud Cabs Services: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>





              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>



              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-dark">
                  Why Choose <span>Garud Cabs Services</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Garud Cabs Services </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919970007784 " className="pc-call">+91 9970007784 </a>
                    </div>
                    <div className="pc-list">
                      <a href="tel:+919970353709 " className="pc-call">+91 9970353709 </a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919970007784 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919970007784 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@garudcabs.com" className="pc-email">
                      booking@garudcabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Garud Cabs Services</strong><br />
                      Office No.101 Anand Heights
                      Chandan Nagar, Kharadi, Pune,
                      Maharashtra, India-  411014




                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetoindorecab;